export default "__VITE_ASSET__CYNZghl___"